// extracted by mini-css-extract-plugin
export default {"scoreContainer":"ScoreBox_scoreContainer__Et+Hz","score":"ScoreBox_score__S49EW"};